<template>
  <Dropdown class="header-drop profile" trigger-class="profile-toggle" dropdown-class="profile-menu">
    <template #trigger>
      <img src="/favicon.png" alt="Зуб" class="profile-img">
      <div class="m-hidden">{{ user.name }}</div>
    </template>
    <template>
      <div class="profile-item w-inline-block" @click="openUserSettings">
        <div class="icon-16px icon-mr8">
          <SettingsIcon />
        </div>
        <div>Настройки профиля</div>
      </div>

      <div v-if="canI('viewStats')" class="profile-item w-inline-block" @click="openStatistics">
        <div class="icon-16px icon-mr8">
          <StatsIcon />
        </div>
        <div>Статистика</div>
      </div>

      <div v-if="canI('addEmployees')" class="profile-item w-inline-block" @click="openInviteEmployee">
        <div class="icon-16px icon-mr8">
          <PeopleIcon />
        </div>
        <div>Сотрудники</div>
      </div>

      <div class="profile-item w-inline-block" @click="logout">
        <div class="icon-16px icon-mr8 w-embed">
          <LogoutIcon />
        </div>
        <div>Выйти</div>
      </div>
    </template>
  </Dropdown>
</template>

<script>
  import {mapActions, mapState} from 'vuex';
  import Dropdown from '@/components/Dropdown';
  import LogoutIcon from '@/icons/logout.svg';
  import SettingsIcon from '@/icons/settings.svg';
  import StatsIcon from '@/icons/stats.svg';
  import PeopleIcon from '@/icons/people.svg';
  import canI from '@/utils/access';
  import UserSettings from '@/containers/header/UserSettings';
  import Stats from '@/containers/header/Stats';
  import InviteEmployee from '@/containers/header/InviteEmployee';

  export default {
    name: 'UserMenu',
    components: {
      Dropdown,
      LogoutIcon,
      SettingsIcon,
      StatsIcon,
      PeopleIcon,
    },
    computed: mapState({
      user: state => state.auth.user,
    }),
    methods: {
      ...mapActions({
        logout: 'auth/logout',
        openModal: 'modal/openModal',
      }),
      openUserSettings () {
        this.openModal({
          component: UserSettings,
          context: {
            attributes: {
              class: 'popup-setteings',
            },
          },
        });
      },
      openStatistics () {
        this.openModal({
          component: Stats,
          context: {
            attributes: {
              windowClass: 'window-fixed',
              class: 'popup-stats',
            },
          },
        });
      },
      openInviteEmployee () {
        this.openModal({
          component: InviteEmployee,
          context: {
            attributes: {
              windowClass: 'window-fixed',
              class: 'popup-team',
            },
          },
        });
      },
      canI,
    },
  };
</script>

<style lang="scss">
  .profile {
    .w-dropdown-list {
      right: 0;
    }
    .profile-item {
      cursor: pointer;
    }
  }
</style>
